import React from "react";

const QuranSurahBanner = ({ label, ornamentSrc }) => {
  if (!label) {
    return null;
  }

  return (
    <div className="quran-surah-banner-wrap" dir="rtl" aria-label={label}>
      <div className="quran-surah-banner" role="heading" aria-level={2}>
        <img
          className="quran-surah-banner-ornament"
          src={ornamentSrc}
          alt=""
          aria-hidden="true"
        />
        <span className="quran-surah-banner-text">{label}</span>
      </div>
    </div>
  );
};

export default QuranSurahBanner;